import React, { useState } from "react";
import styled from "styled-components";
import MenuItem from "@material-ui/core/MenuItem";

import { Select } from "../../../../theme";
import policies from "./assets/policies.json";

const listedPolicies = [
  "Workplace_closing",
  "Stay_at_home_requirements",
  "Restrictions_on_internal_movement",
  "International_travel_controls",
  "Cancel_public_events",
  "Restrictions_on_gatherings",
  "School_closing",
];
const plots = require.context("./assets", false, /.*\.svg$/);

const Container = styled.div`
  margin: 60px 0;

  @media (max-width: 1599px) {
    margin: 50px 0;
  }

  @media (max-width: 767px) {
    margin: 40px 0;
  }

  img {
    margin-top: 0;
  }
`;

const Inputs = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;

  @media (max-width: 767px) {
    display: block;
    margin: 0;
  }

  > div {
    width: calc(50% - 25px);

    @media (max-width: 767px) {
      margin-bottom: 30px;
      width: 100%;
    }
  }
`;

function CovidWorldResponsePlots() {
  const [policy, setPolicy] = useState("School_closing");
  const [order, setOrder] = useState("timeline");

  return (
    <Container>
      <Inputs>
        <div>
          <Select
            label="Mesure contre le Covid-19 :"
            value={policy}
            onChange={(e) => setPolicy(e.target.value)}
          >
            {policies.map(({ value, label }) => {
              if (listedPolicies.indexOf(value) >= 0) {
                return (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                );
              }
              return null;
            })}
          </Select>
        </div>
        <div>
          <Select
            label="Trié par :"
            value={order}
            onChange={(e) => setOrder(e.target.value)}
          >
            <MenuItem value="timeline">Ordre chronologique</MenuItem>
            <MenuItem value="delay">Délai avant adoption</MenuItem>
          </Select>
        </div>
      </Inputs>
      <img src={plots(`./${policy}_${order}.svg`)} alt="" />
    </Container>
  );
}

export default CovidWorldResponsePlots;
